import { render, staticRenderFns } from "./AssetImageGenerationInfo.vue?vue&type=template&id=1283b89e&lang=pug"
import script from "./AssetImageGenerationInfo.vue?vue&type=script&lang=js"
export * from "./AssetImageGenerationInfo.vue?vue&type=script&lang=js"
import style0 from "./AssetImageGenerationInfo.vue?vue&type=style&index=0&id=1283b89e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports